// extracted by mini-css-extract-plugin
module.exports = {"container":"lx","title":"ly","image":"lz","imageLogo":"lA","info":"lB","infoContainer":"lC","infoTitle":"lD","infoValue":"lE","goBack":"lF"};